import React, { PureComponent } from "react";
import { TransContext } from "../../Context";
import OutsideNotifier from "../OutsideNotifier";
import { Consume } from "../../Context/Consumer";
import config from "../../common/config";
import { getTrans } from "../../common";

class ToastMsg extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      closeModal: true,
    };
    this.toastMsgInterval = null;
  }

  componentDidMount() {
    this.toastMsgInterval =
      !this.props.objShowHideToast.isCancelPopup &&
      setTimeout(() => {
        this.onClose();
      }, 5000);
  }

  onClose = () => {
    let self = this;
    !self.props.objShowHideToast.isCancelPopup &&
      clearInterval(self.toastMsgInterval);
    self.props.showHideToast(
      false,
      "",
      false,
      self.props.objShowHideToast.isCancelPopup,
      self.props.objShowHideToast.isManageScreen
    );
  };

  render() {
    let self = this;
    let { state, props } = self;
    let { closeModal } = state;
    let { objShowHideToast, TransData } = props;
    const transData = TransData.data;

    let popupBody = (
      <div className="si-popup__wrap si-toast__popup si-fade in" style={{ zIndex: "999999999999" }}>
        <div className="si-popup__container">
          <div className="si-popup__body">
            <div
              className="si-popup__close"
              onClick={this.onClose}
              style={{ userSelect: "auto" }}
            >
              <div
                className="si-btn__adRe"
                style={{ userSelect: "auto" }}
              ></div>
            </div>
            <div
              className={
                "si-toast__box " +
                (objShowHideToast.isWarning ? "si-danger" : "si-success")
              }
            >
              <div className="si-toast__icon"></div>
              <div className="si-toast__text">
                <span>{objShowHideToast.msg}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    if (objShowHideToast.isCancelPopup) {
      popupBody = (
        <div className="si-popup__wrap si-league__popup si-fade in">
          <div className="si-popup__container">
            <div className="si-popup__head">
              <div className="si-popup__close" onClick={this.onClose}>
                <div className="si-btn__adRe"></div>
              </div>
              <div className="si-popup__title">
                <span>
                  {getTrans(transData, "are_you_sure", "Are you sure?")}
                </span>
              </div>
              <div className="si-popup__para">
                <span>
                  {getTrans(
                    transData,
                    "unsave_change_cancel",
                    "Any unsaved changes will be cancelled"
                  )}
                </span>
              </div>
            </div>
            <div className="si-popup__body"></div>
            <div className="si-popup__foot">
              <div
                className="si-btn si-btn__primary si-btn__primary--outline"
                onClick={this.onClose}
              >
                <span>
                  {getTrans(transData, "no_keep_edit", "No, Keep Editing")}
                </span>
              </div>
              <div
                className="si-btn si-btn__primary"
                onClick={() =>
                  self.props.history.push(config.BASE_DOMAIN_LANG + "my-team")
                }
              >
                <span>{getTrans(transData, "Yes_Txt", "Yes")}</span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return closeModal ? (
      <OutsideNotifier handler={this.onClose}>{popupBody}</OutsideNotifier>
    ) : null;
  }
}

export default Consume(ToastMsg, [TransContext]);
